// extracted by mini-css-extract-plugin
export default {"titleHeading":"privacyPolicy_titleHeading__64J-E","privacyWrapper":"privacyPolicy_privacyWrapper__5Kaj3","privacyInner":"privacyPolicy_privacyInner__WgrNj"};